import axios from 'axios';

export const businessGroupService = {
    getBusinessGroupById,
    addBusinessGroup,
    updateBusinessGroup,
    deleteBusinessGroup,
    getBusinessGroupsByOpu
}
export default businessGroupService;

//async function getBusinessGroups() {
//    return await axios.get('/groups');
//}

async function getBusinessGroupById(groupId) {
    return await axios.get(`/BusinessGroup /${groupId}`);
}

async function addBusinessGroup(group) {
    return await axios.post('/BusinessGroup/', group);
}

async function updateBusinessGroup(group) {
    return await axios.put('/BusinessGroup/', group);
}

async function deleteBusinessGroup(groupId) {
    return await axios.delete(`/BusinessGroup/${groupId}`);
}

// BusinessBusinessGroup Chargers
async function getBusinessGroupsByOpu() {
    return await axios.get('/BusinessGroup/by-operator');
}
